import { MutationCache, QueryCache, QueryClient } from "@tanstack/react-query";

import { handleApiError, shouldRetryOnError } from "./api";

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 5000,
      retry: shouldRetryOnError,
    },
  },
  queryCache: new QueryCache({
    onError: (error, query) => {
      handleApiError(
        error,
        query.meta !== undefined && query.meta.hideError === true,
      );
    },
  }),
  mutationCache: new MutationCache({
    onError: (error, _variables, _context, mutation) => {
      handleApiError(
        error,
        mutation.meta !== undefined && mutation.meta.hideError === true,
      );
    },
  }),
});
